import { findIndex } from "lodash"

const initialState = {
  positiveLead: {
    x1: -35,
    y1: 128,
    x2: -12,
    y2: 150
  },
  negativeLead: {
    x1: 12,
    y1: 150,
    x2: 35,
    y2: 128
  },
  positiveLeads: {
    '1': false,
    '2': false
  },
  negativeLeads: {
    '1': false,
    '2': false
  },
  leads: [
    {
      held: false,
      controlsVisibile: false
    },
    {
      held: false,
      controlsVisibile: false
    },
    {
      held: false,
      controlsVisibile: false
    },
    {
      held: false,
      controlsVisibile: false
    }
  ]
}

export default (state = initialState, action) => {
  let currentLead;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_POWER_SUPPLY_LEAD" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("powerSupplyLead")){
            currentLead = state.protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.protocolSection.scene.apparatus.powerSupplyLead, { id: action.payload.id })]
          }
      }
  }

  switch (action.type) {

    case 'CREATE_POWER_SUPPLY_LEAD':

      //Create new obj from template state
      let newObj = { ...initialState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("powerSupplyLead")){
        protocolSection.scene.apparatus.powerSupplyLead = [ ...protocolSection.scene.apparatus.powerSupplyLead, newObj ]
      } else {
        protocolSection.scene.apparatus.powerSupplyLead = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }


    case "SET_POSITIVE_POWER_SUPPLY_LEAD_POSITION":
      //Payload = {positiveLead}
      currentLead.positiveLead = action.payload.positiveLead
      protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead
      return { ...state, ...{  protocolSection: protocolSection  } }

    case "SET_NEGATIVE_POWER_SUPPLY_LEAD_POSITION":
      //Payload = {negativeLead}
      currentLead.negativeLead = action.payload.negativeLead
      protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead
      return { ...state, ...{  protocolSection: protocolSection  } }
      // return { ...state, ...{ negativeLead: action.payload.negativeLead } };


    case "SET_POSITIVE_POWER_SUPPLY_LEAD_CONNECTION":
      //Payload = {negativeLead}
      console.log({currentLead});
      console.log({action});
      currentLead.positiveLeads[action.payload.index] = action.payload.leadConnected
      protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead
      return { ...state, ...{  protocolSection: protocolSection  } }

      // let positiveLeads = state.positiveLeads
      // positiveLeads[action.payload.index] = action.payload.leadConnected

      // return { ...state, ...{ positiveLeads: positiveLeads } };

    case "SET_NEGATIVE_POWER_SUPPLY_LEAD_CONNECTION":
      //Payload = {negativeLead}
      currentLead.negativeLeads[action.payload.index] = action.payload.leadConnected
      protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead
      return { ...state, ...{  protocolSection: protocolSection  } }
      // let negativeLeads = state.negativeLeads
      // negativeLeads[action.payload.index] = action.payload.leadConnected

      // return { ...state, ...{ negativeLeads: negativeLeads } };

    case 'SET_POWER_SUPPLY_LEAD_HELD':
        const index = action.payload.id
        currentLead.leads[index].held = action.payload.held
        protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead

        return { ...state, ...{
          protocolSection: protocolSection
        } }

    case 'SET_POWER_SUPPLY_LEAD_CONTROLS_VISIBLE':

        // Hide the controls for all the other powersupply leads
        if(protocolSection.scene.apparatus.hasOwnProperty("powerSupplyLead")){
          currentLead.leads.forEach((lead) => {
              lead.controlsVisible = false;
          })
        }

        // Make the current lead controls visible
        currentLead.leads[action.payload.index].controlsVisible = action.payload.controlsVisible
        protocolSection.scene.apparatus.powerSupplyLead[findIndex(state.powerSupplyLead, { id: action.payload.id })] = currentLead

        return { ...state, ...{
          protocolSection: protocolSection
        } }

    case 'HIDE_ALL_CONTROLS':
      
        // Hide the controls for all the other powersupply leads
        if(protocolSection.scene.apparatus.hasOwnProperty("powerSupplyLead")){
          protocolSection.scene.apparatus.powerSupplyLead.forEach((powerSupplyLead) => {
            powerSupplyLead.leads.forEach((lead) => {
              lead.controlsVisible = false;
            })
          })
        }

        return { ...state, ...{
          protocolSection: protocolSection
        } }

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('powerSupplyLead')) {

        protocolSection.scene.apparatus.powerSupplyLead = action.payload.lastState.scene.apparatus.powerSupplyLead

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      } else {
        return state;
      }

    default:
      return state;
  }
}
